import { Stack } from '@components/ui';
import { ReactNode } from 'react';

type ServicePacketListProps = {
  children: ReactNode;
};

export const ServicePacketList = ({ children }: ServicePacketListProps) => <Stack spacing={3}>{children}</Stack>;
